export enum PostTypeEnum {
  POLITICAL_ATTACK_TYPE_ID = 8
}